import './CareerPage.css';
import { useLocation, useParams, useHistory } from 'react-router-dom';
import { Fragment, useEffect, useState } from 'react';
import ReactMarkdown from 'react-markdown';
import SideMenu from './SideMenu';

export default function CareerPage(props) {

    const subMenu = [
        { path: "faculty", hu: "Egyetemi életpálya", en: "Faculty career"},
        { path: "academic", hu: "Akadémiai életpálya", en: "Academic career"},
    ];

    const timelineItems = {
        faculty: [
            { id: "tanarseged", hu: "Egyetemi tanársegéd", en: "Assistant lecturer"},
            { id: "adjunktus", hu: "Egyetemi adjunktus", en: "Assistant professor"},
            { id: "docens", hu: "Egyetemi docens", en: "Associate professor"},
            { id: "tanar", hu: "Egyetemi tanár", en: "Full professor"}
        ],
        academic: [
            { id: "phd", hu: "Doktori (PhD)", en: "Doctor (PhD)"},
            { id: "habil", hu: "Habilitáció", en: "Habilitation"},
            { id: "mtadoktor", hu: "MTA doktora", en: "Doctor of the HAS"},
            { id: "akademikus", hu: "Akadémikus", en: "Member of the HAS"}
        ]
    }

    const [description, setDescription] = useState("");
    const [intro, setIntro] = useState("");
    const location = useLocation();
    const param = new URLSearchParams(location.search);
    const lang = param.get("lang") === "en" ? "en" : "hu";
    const history = useHistory();
    let { selectedMenu="faculty", activeItem } = useParams();
    if (!activeItem)
        activeItem = timelineItems[selectedMenu][0].id;

    useEffect(() => {
        fetch(`./career/${selectedMenu}_intro_${lang}.md`)
            .then(res => res.text())
            .then((md) => setIntro(md));
    }, [selectedMenu, lang]);
        
    useEffect(() => {
        fetch(`./career/${selectedMenu}_${activeItem}_${lang}.md`)
            .then(res => res.text())
            .then((md) => setDescription(md));
    }, [activeItem, selectedMenu, lang]);

    return (
        <div id="career-main" className="page-main">
            <SideMenu menuItems={subMenu} selectedMenuItem={selectedMenu} pathPrefix="/career/" lang={lang} />
            <div className="content-panel">
                <div className="content-main">
                    <h1>{subMenu.find(d => d.path === selectedMenu)[lang]}</h1>
                    <ReactMarkdown>
                        {intro}
                    </ReactMarkdown>
                    <Timeline 
                        selected={activeItem}
                        onClick={path => history.push(`/career/${selectedMenu}/${path}${location.search}`)}
                    >
                        {timelineItems[selectedMenu].map((d, ix) => <div item={d.id} key={ix}>{d[lang]}</div>)}
                    </Timeline>
                    <div className="description">
                    <ReactMarkdown>
                        {description}
                    </ReactMarkdown>
                    </div>
                </div>
            </div>            
        </div>        
    );
}

function Timeline(props) {
    return <div className="time-line">
        {props.children.map((child, ix) => (
            <Fragment key={ix}>
                <div 
                    className={`time-line-item-container ${(props.selected && props.selected === child.props.item) ? "time-line-item-selected-container" : ""}`}
                    onClick={() => props.onClick(child.props.item)}
                >
                    {ix > 0 && <div className="triangle-in"/>}
                    <div className="time-line-item">
                        {child}
                    </div>
                    {ix < props.children.length-1 && <div className="triangle-out"/>}
                </div>
                {ix < props.children.length-1 && <><div className="triangle-in"/><div className="triangle-out"/></>}
            </Fragment>
        ))}
    </div>;
}